import React from 'react';
import { statusColors } from './ConnectionData'; // Adjust path if necessary

const Legend = () => {
  return (
    <div style={{
      position: 'absolute',
      top: 10,
      right: 10,
      background: 'white',
      padding: 10,
      borderRadius: 5,
      boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
      zIndex: 1 // Ensures it’s above other elements
    }}>
      <h3 style={{ margin: 0, marginBottom: 10 }}>Connection Status</h3>
      {Object.entries(statusColors).map(([status, color]) => (
        <div key={status} style={{ display: 'flex', alignItems: 'center', marginBottom: 5 }}>
          <div style={{
            width: 20,
            height: 20,
            backgroundColor: `#${(color & 0xffffff).toString(16).padStart(6, '0')}`,
            marginRight: 10
          }}></div>
          <span>{status}</span>
        </div>
      ))}
    </div>
  );
};

export default Legend;